module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div>\n    <div class="spinner" data-spinner-color="#000" data-spinner-size="20">\n        <div class="ladda-label sync-state"></div>\n        <i class="glyphicon glyphicon-exclamation-sign important"></i>\n    </div>\n    <div class="dropdown spinner get-code-container">\n        <input type="text" style="position: absolute;left: -9999px;" />\n        ';
 if (isEnhancedCopyCodeEnabled && !isNewDashboardExperience) { ;
__p += '\n            <button class="dropdown-toggle copy-code-btn btn btn-white" data-toggle="dropdown">Copy Code<span class="indicator">* </span><span class="caret"></span></button>\n            <ul class="dropdown-menu more-dropdown-menu copyCodeDropDown">\n                <li><a class="menu-item get-enhanced-code">Enhanced</a></li>\n                ';
 if(!isNewDashboardExperience) { ;
__p += '\n                    <li><a class="menu-item get-code-btn">Legacy</a></li>\n                ';
 } ;
__p += '\n            </ul>\n        ';
 } ;
__p += '\n        ';
 if (!isEnhancedCopyCodeEnabled && !isNewDashboardExperience) { ;
__p += '\n            <button class="get-code-btn btn btn-white copy-code-btn">Copy Code<span class="indicator">*</span></button>\n        ';
 } ;
__p += '\n    </div>\n\n   ';
 if (isEmailInCreatorEnabled) { ;
__p += '\n       <div class="copy-email-btn-region"></div>\n   ';
 } ;
__p += '\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/editor/ExperienceSyncStateView.tpl
// module id = 2937
// module chunks = 0